"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const subscriber_1 = require("./subscriber");
/* HOOKS */
const Hooks = {
    store: {
        change: new subscriber_1.default(),
        changeBatch: new subscriber_1.default(),
        new: new subscriber_1.default()
    }
};
/* EXPORT */
exports.default = Hooks;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9va3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaG9va3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFlBQVk7O0FBRVosNkNBQXNDO0FBR3RDLFdBQVc7QUFFWCxNQUFNLEtBQUssR0FBRztJQUVaLEtBQUssRUFBRTtRQUVMLE1BQU0sRUFBRSxJQUFJLG9CQUFVLEVBQXNCO1FBRTVDLFdBQVcsRUFBRSxJQUFJLG9CQUFVLEVBQWdDO1FBRTNELEdBQUcsRUFBRSxJQUFJLG9CQUFVLEVBQVk7S0FFaEM7Q0FFRixDQUFDO0FBRUYsWUFBWTtBQUVaLGtCQUFlLEtBQUssQ0FBQyJ9